// Feature flags configuration
// Enable/disable features across the application

export const FEATURE_FLAGS = {
  // Golden SQL feature - Store and reuse frequently used SQL queries
  GOLDEN_SQL: false,

  // Instructions feature - Custom instructions for SQL generation
  INSTRUCTIONS: true,

  // Conversation features
  CONVERSATION_TEMPLATES: true,
  MESSAGE_SEARCH: true,

  // Upcoming features (not yet implemented)
  SMART_QUERY_SUGGESTIONS: false,
  CONVERSATION_SHARING: false,
  QUERY_HISTORY_FAVORITES: false,
};

// Helper function to check if a feature is enabled
export const isFeatureEnabled = (feature: keyof typeof FEATURE_FLAGS): boolean => {
  return FEATURE_FLAGS[feature] ?? false;
};